import type { AnchorHTMLAttributes, ReactNode } from 'react';
import { VisuallyHidden } from '@workramp/ui';
import { LinkOverlay } from './InteractiveCard.styles';

interface InteractiveCardProps {
  href?: string;
  onPress?: () => void;
  actionText?: ReactNode;
  target?: AnchorHTMLAttributes<HTMLAnchorElement>['target'];
}
export function InteractiveCard({ href, target, onPress, actionText }: InteractiveCardProps) {
  const isInteractive = !!(href || onPress);

  if (!isInteractive) {
    return null;
  }

  return (
    <LinkOverlay href={href} target={target || '_self'} onPress={onPress} data-testid="interactive-card">
      <VisuallyHidden>{actionText}</VisuallyHidden>
    </LinkOverlay>
  );
}
